import React, { useCallback, useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import FormGroup from 'react-bootstrap/FormGroup'
import FormLabel from 'react-bootstrap/FormLabel'
import FormControl from 'react-bootstrap/FormControl'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { loginService } from 'app/services/client'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { isTokenExpired, setUserToken } from 'app/utils/hooks'
import { handleServerAPIError } from 'app/services/utils'

const CenteredRow = styled(Col)`
    float: none;
    margin: 0 auto;
`

const LoginView = () => {
    const [login, setLogin] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const onLogin = useCallback(
        (event: any) => {
            event.preventDefault()
            loginService(login, password)
                .then(res => {
                    const result = res.data
                    setUserToken(result.token, result.expired)
                    // navigate(-1)
                    navigate(APP_ROUTES.VIEW_APPS_EDITOR)
                })
                .catch(e => handleServerAPIError(e, dispatch, navigate))
        },
        [navigate, login, password, handleServerAPIError, dispatch],
    )

    useEffect(() => {
        if (!isTokenExpired()) {
            navigate(APP_ROUTES.VIEW_APPS_EDITOR)
        }
    }, [])

    return (
        <CenteredRow xs="3">
            <Form className="m-3" onSubmit={onLogin}>
                <FormGroup className="mb-3">
                    <FormLabel>Login</FormLabel>
                    <FormControl
                        type="text"
                        id="login"
                        name="login"
                        value={login}
                        onChange={e => setLogin(e.target.value)}
                    />
                </FormGroup>
                <FormGroup className="mb-3">
                    <FormLabel>Password</FormLabel>
                    <FormControl
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                </FormGroup>
                <Button type="submit">Login</Button>
            </Form>
        </CenteredRow>
    )
}

export default LoginView
